export interface TouchEnvironment {
  coarsePointer: boolean;
  maxTouchPoints: number;
}

export function hasTouchInput(environment: TouchEnvironment = readTouchEnvironment()): boolean {
  return environment.coarsePointer || environment.maxTouchPoints > 0;
}

function readTouchEnvironment(): TouchEnvironment {
  return {
    coarsePointer: globalThis.matchMedia?.("(pointer: coarse)").matches ?? false,
    maxTouchPoints: globalThis.navigator?.maxTouchPoints ?? 0,
  };
}
